export default __webpack_public_path__ + "static/media/light-pro.85def4f1.jpg";